var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28.75,
    viewBox: "0 0 30 28.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library_books-24px",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M5.773,7.814,4,7.145v22.2c0,1.692.73,2.407,2.455,2.407H29.091l-.682-1.738H5.773ZM31.545,3H11.364c-1.725,0-2.455.047-2.455,1.738V25.866c0,1.692.73,1.738,2.455,1.738H31.545C33.27,27.6,34,27.558,34,25.866V4.738C34,3.047,33.27,3,31.545,3Zm.682,22.866H10.682V4.738H32.227Zm-17.045-12.1H27.727v2.407H15.182Zm0,4.613h6.273v2.407H15.182Zm0-9.227H27.727v2.407H15.182Z",
    fill: "#f8f9fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookbook);
export default __webpack_public_path__ + "static/media/cookbook.2c9917a856425ab32c6771e787372bd0.svg";
export { ForwardRef as ReactComponent };